import { useFiscalPeriodsQuery } from "../api/reference";

export function useFiscalDefaults() {
  const { data, isLoading } = useFiscalPeriodsQuery();
  const today = new Date().toISOString().slice(0, 10);

  const defaultPeriod = data?.defaultPeriod ?? "";
  const startsOn = data?.startsOn ?? "";
  const endsOn = data?.endsOn ?? today;
  const defaultDate =
    startsOn && endsOn && today >= startsOn && today <= endsOn
      ? today
      : defaultPeriod
        ? `${defaultPeriod}-01`
        : today;

  return {
    defaultPeriod,
    defaultDate,
    startsOn: startsOn || defaultDate,
    endsOn: endsOn || defaultDate,
    fiscalYearName: data?.fiscalYearName ?? "",
    months: data?.months ?? [],
    isLoading,
  };
}
